import React, { useState } from 'react'
import { Grid, Typography, TextareaAutosize, Modal } from '@material-ui/core/'
import { DialogModal, Button } from 'components/UI/'
import { IconHeart } from 'components/SvgIcons/'
import apiChat from '../../../../../../api/chat'
import closeIcon from '../../../../../../assetss/img/closeModalIcon.svg'
import c from 'classnames'
import './index.scss'

const FeadbackAccept = ({ open, setOpen }) => (
  <Modal
    open={open}
    onClose={setOpen}
  >
    <div className='modalFeeatbackAccept' onClick={setOpen}>
      <div className='textAccept'>
        <img className='iconClose' src={closeIcon} onClick={setOpen} />
        Thanks for sharing your feedback!
      </div>
    </div>
  </Modal>
)

const FeadbackMeet = ({ openReview, setOpenReview, name, accessKey, meeting, setOpenFailed, getMeeting }) => {
  const [activeColor, setActiveColor] = useState()
  const [activeItem, setActiveItem] = useState(null)
  const [value, setValue] = useState('')
  const [open, setOpen] = useState(false)

  const iconsHeart = Array.from(Array(5).keys())

  const sendReview = () => {
    apiChat.sendReviewSuccess(
      accessKey,
      meeting?.uuid,
      +activeItem + 1,
      value,
    ).then(() => {
      setOpenReview(false)
      setOpen(true)
      getMeeting()
    })
  }

  return (
    open ? (
      <FeadbackAccept open={open} setOpen={() => setOpen(false)} />
    ) : (
      <DialogModal
        open={openReview}
        onClose={() => setOpenReview(false)}
        closeBtn
        height='469px'
        width='320px'
      >
        <Grid className='boxFeadbackMeet'>
          <Typography className='titleName'>How was your meeting <br /> with {name}?</Typography>
          <Grid className='iconsContainer'>
            {iconsHeart?.map((_, ind) => {
              return (
                <IconHeart
                  onMouseLeave={() => setActiveColor()}
                  onMouseMove={() => setActiveColor(ind)}
                  customClass={c('hoverItem', { activeHoverItem: ind <= activeColor || (activeItem !== null && activeItem >= ind) })}
                  key={ind}
                  onClick={() => setActiveItem(activeItem === null ? ind : ind === activeItem ? null : ind)}
                />
              )
            })}
          </Grid>
          <Grid className='textContainer'>
            <Typography className='inputTitle'>Let us know how it went:</Typography>
            <TextareaAutosize
              onChange={e => setValue(e?.target?.value)}
              placeholder='Feedback'
              className='inputCustom'
              value={value}
              rowsMin={4}
            />
          </Grid>
          <Button className='nextBtn' onClick={sendReview}>
            Send feedback
          </Button>
          <Button
            className='prevBtn'
            onClick={() => {
              setOpenFailed(true)
              setOpenReview(false)
            }}
          >
            Meeting didn't take place
          </Button>
        </Grid>
      </DialogModal>
    )
  )
}

export default FeadbackMeet
